import { render } from "./UserInfo.vue?vue&type=template&id=1fb696ec&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=1fb696ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb696ec"]])

export default __exports__